// test118
(118 && 0);
